import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'semantic-ui-css/semantic.min.css'
// import App from './App';
import PaymentGateway from './Pages/paymentGateway'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <PaymentGateway/>
  </React.StrictMode>
);

reportWebVitals();
